module.exports = "/static/b1eb2833a22f6798dac088c6ea30c015.ico";